import { useAuth0 } from '@auth0/auth0-react';
import { useLocation } from 'react-router-dom';
import Box from 'carbon-react/esm/components/box';
import Typography from 'carbon-react/esm/components/typography';
import Button from 'carbon-react/esm/components/button/__next__';
import { useLogger } from '../../context/useLogger';
import PublicNavbar from '../../components/PublicNavbar';
import { isSafeInternalPath } from '../../utils/redirectValidation';

const Login = () => {
  const { loginWithRedirect } = useAuth0();
  const logger = useLogger();
  const location = useLocation();
  const from = (location.state as { from?: string } | null)?.from;

  const handleLogin = async () => {
    try {
      await loginWithRedirect({
        authorizationParams: {
          redirect_uri: `${window.location.origin}/callback`,
        },
        appState: isSafeInternalPath(from) ? { returnTo: from } : undefined,
      });
    } catch (error) {
      logger.error('Login failed:', error);
    }
  };

  return (
    <Box
      backgroundColor="black"
      position="fixed"
      top={0}
      left={0}
      right={0}
      bottom={0}
      width="100vw"
      height="100vh"
      display="flex"
      flexDirection="column"
      overflow="auto"
    >
      <PublicNavbar />

      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        width="100%"
        flex="1"
      >
        <img src="/automate-processes.gif" alt="Sage" id="homeIllustration" />
        <Typography variant="h1" size="L" inverse mb={2}>
          Bienvenue dans Sage EDI Online
        </Typography>
        <Typography variant="h2" size="L" inverse mb={2}>
          L&apos;espace de suivi de vos déclarations sociales
        </Typography>
        <Button onClick={handleLogin} variantType="primary" size="large" p="0.8em 80px" mt={4}>
          Accéder
        </Button>
      </Box>

      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        maxWidth="760px"
        alignSelf="center"
        mb={20}
      >
        <Typography variant="p" size="M" inverse mt={2}>
          © Sage Group plc., tous droits réservés.
        </Typography>
        <Typography variant="p" size="M" inverse textAlign="center">
          L&apos;utilisation de ce service est régie par des conditions générales et des conditions
          particulières, qui ont été dûment acceptées par chaque Partenaire ou Client de Sage à
          l&apos;occasion de la souscription au-dit service. Les conditions applicables sont
          librement consultables en ligne sur le site{' '}
          <a className="login-legal-link" href="https://www.sage.com/fr-fr">
            www.sage.com/fr-fr
          </a>
          , rubrique « Informations légales », puis « Tarifs et Conditions Générales ».
        </Typography>
      </Box>
    </Box>
  );
};

export default Login;
